module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"step":"Steg","markAsRead":"Marker som lest","readDone":"Artikkelen lest"},"en":{"step":"Step","markAsRead":"Mark as read","readDone":"Article read"}}')
  delete Component.options._Ctor
}
